export default "__VITE_ASSET__7098d940__"